import React from "react";

const Footer = () => {
    return (
        <div className="footer">
            Happy Thoughts Project by Camilla Hallberg 2022 <span className="letter-emoji" role="img" aria-label="letter emoji">💌</span>
        </div>
    )
}

export default Footer 